import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Box, Grid, IconButton, Typography } from '@material-ui/core'
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import CollaboratorLaboratoryGrid from 'src/components/CollaboratorLaboratoryGrid/CollaboratorLaboratoryGrid'
import { colleaguesWorkImg } from 'src/assets/images'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './LaboratoryContent.styles'
import {
  PROJECTIONIST_LIST,
  STAFF_RESEARCH_LIST,
  STRUCTURE_LIST,
  TEACHERS_LIST,
  STRUCTURE_IMG_LIST
} from './LaboratoryContent.data'
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.min.css'

SwiperCore.use([Navigation, Pagination, Autoplay])

const LaboratoryContent = () => {
  const { t } = useTranslation()
  const classesGlobal = useGlobalStyles()
  const classes = useStyles()
  const [swiperInstance, setSwiperInstance] = useState<any>(null)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setInit] = useState(false)

  return (
    <>
      <Box className={classesGlobal.containerPages}>
        <BreadcrumbsComponent
          crumbs={[
            { label: t('navbar.start'), path: '/' },
            { label: t('laboratory.title') }
          ]}
        />
        <Box className={classes.teamContainer}>
          <Typography variant="h3" className={classesGlobal.titleSection}>
            {t('laboratory.team')}
          </Typography>
          <Box className={classes.teamWrapper}>
            <Box className={classes.teamInformation}>
              <Box>
                <Typography className={classes.teamDescription}>
                  {t('laboratory.team-description')}
                </Typography>
              </Box>
              <Box className={classes.teamMetricsSection}>
                <Box>
                  <Typography variant="h3" className={classes.teamMetricsValue}>
                    +60
                  </Typography>
                  <Typography variant="h6" className={classes.teamMetricsText}>
                    {t('laboratory.employees')}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="h3" className={classes.teamMetricsValue}>
                    {25}
                  </Typography>
                  <Typography variant="h6" className={classes.teamMetricsText}>
                    {t('laboratory.researchers')}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="h3" className={classes.teamMetricsValue}>
                    {22}
                  </Typography>
                  <Typography variant="h6" className={classes.teamMetricsText}>
                    {t('laboratory.developers')}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <img
              src={colleaguesWorkImg}
              alt={t('laboratory.team')}
              className={classes.laboratoryImg}
            />
          </Box>
        </Box>
        <CollaboratorLaboratoryGrid
          title="laboratory.teachers"
          data={TEACHERS_LIST}
        />
        <CollaboratorLaboratoryGrid
          title="laboratory.staff-research"
          data={STAFF_RESEARCH_LIST}
        />
        <CollaboratorLaboratoryGrid
          title="laboratory.red-projects"
          data={PROJECTIONIST_LIST}
        />
        <Box>
          <Typography
            variant="h3"
            className={`${classes.titleSection} ${classes.spacing}`}
          >
            {t('laboratory.structure')}
          </Typography>
          <Grid container className={classes.gridContainer} spacing={3}>
            {STRUCTURE_LIST.map((line, index) => (
              <Grid
                xs={12}
                sm={6}
                md={3}
                item
                key={index}
                className={classes.gridItemStructureList}
              >
                <Box className={classes.iconBackground}>
                  <img
                    src={line.src}
                    alt={line.text}
                    className={classes.icon}
                  />
                </Box>
                <Typography
                  variant="body1"
                  className={classes.technologiesTextIcon}
                >
                  {t(line.text)}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box className={classes.structureSwiperContainer}>
          <IconButton
            aria-label={t('arial-label.previous-slide')}
            className={classes.navButton}
            onClick={() => swiperInstance?.slidePrev()}
          >
            <ArrowBackIos style={{ marginLeft: '4px' }} />
          </IconButton>
          <Swiper
            observer={true}
            observeParents={true}
            threshold={5}
            loop={true}
            centeredSlides={true}
            className={classes.swiperContainer}
            onSwiper={(swiper) => {
              setSwiperInstance(swiper)
              setInit(true)
            }}
            onInit={(swiper) => {
              setSwiperInstance(swiper)
            }}
            breakpoints={{
              600: { slidesPerView: 1 },
              960: { slidesPerView: 3 }
            }}
          >
            {STRUCTURE_IMG_LIST.map((data: any) => (
              <SwiperSlide key={data.id}>
                <img
                  title={data.title}
                  src={data.src}
                  alt={data.alt}
                  className={classes.swiperSlideImg}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <IconButton
            aria-label={t('arial-label.next-slide')}
            className={classes.navButton}
            onClick={() => swiperInstance?.slideNext()}
          >
            <ArrowForwardIos />
          </IconButton>
        </Box>
      </Box>
    </>
  )
}

export default LaboratoryContent
